import RestClient from './rest-client'

export default class Invoice extends RestClient {
  static get url () {
    return this.apiUrl + '/invoices'
  }
  
  static get paramKey () {
    return 'invoice'
  }

  static async requestInvoice (params) {
    const { data } = await this._post(`${this.url}/request_invoice`, params)
    return data
  }

  static async download (id) {
    const { data } = await this.http({
      url: `${this.url}/${id}/download`,
      method: 'POST',
      responseType: 'blob',
      headers: this.headers
    })
    return data
  }

  static async export (params) {
    const { data } = await this.http({
      url: this.url + '/export',
      method: 'POST',
      responseType: 'blob',
      params,
      headers: this.headers
    })
    return data
  }

  async rejectInvoice () {
    const { data } = await this.constructor._put(`${this.constructor.url}/${this.id}/reject_invoice`)
    return data
  }
}
